import type { ApiResponse } from '@/utils/api'
import { DomainApiError } from '@queries/shared/domain-api-error'
import { useMessage } from '@/composables/useMessage'
import { getI18nTranslate, hasI18nTranslation } from '@/utils/i18nUtils'

// 後端有些情境會回 isSuccess:true 但仍帶 resultCode（例如 G03：查詢正常但無資料可告知），
// 這種 resultCode 若剛好在翻譯字典裡有對應項目，就用 info 提示告知使用者；沒有對應翻譯的
// resultCode（大多數正常流程不會帶，或只是後端內部標記）維持現狀，不主動顯示任何提示，
// 避免翻譯字典之外的 resultCode 造成非預期的提示轟炸
export const unwrapApiResponse = <T>(
  response: ApiResponse<T>,
  options: { silentResultCodes?: Array<string | number> } = {}
): T => {
  if (response.isSuccess) {
    if (response.resultCode && !options.silentResultCodes?.includes(response.resultCode)) {
      const resultCodeKey = `ServerResponse.ResultCode.${response.resultCode}`
      if (hasI18nTranslation(resultCodeKey)) {
        useMessage().openMessage('info', getI18nTranslate(resultCodeKey))
      }
    }

    return response.result as T
  }

  throw new DomainApiError({
    message: response.message || 'Unknown API error',
    resultCode: response.resultCode,
    retryable: false
  })
}
